export const TimeOut = async (time = 1000) => {
	return await new Promise(resolve => {
		const timeout = setTimeout(() => {
			resolve(true)
			clearTimeout(timeout)
		}, time)
	})
}
